import React, { useState, useEffect } from "react";
import Article from "../../components/Article/Article";
import { blog01, blog02, blog03, blog04, blog05 } from "./imports";
import "./Blog.css";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);

  const fetchBlogs = async () => {
    const data = await getDocs(collection(db, "blogs"));
    data.forEach((item) => {
      setBlogs((blogs) => [...blogs, item.data()]);
    });
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  console.log(blogs);

  return (
    <div className="blog section__padding" id="blog">
      <div className="blog-heading">
        <h1 className="gradient__text">
          A lot is happening, <br /> We are blogging about it.
        </h1>
      </div>
      <div className="blog-container">
        <div className="blog-container_groupA">
          <Article
            imgUrl={blog01}
            date="Sep 26, 2021"
            text="JavaScript Blues"
            author="Kartik Jha"
          />
        </div>
        <div className="blog-container_groupB">
          {blogs.map((blogPost) => {
            return (
              <Article
                imgUrl={blogPost.cover_img}
                date={blogPost.date}
                text={blogPost.title}
                author={blogPost.author}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Blog;
